/**
 * Suncast Application client side validator functions
 * Contains all client-side validation functionality for the application
 * @module validators
 * @author Scott Gingerysty (Fresche Solutions)
 * @date May 2020
 */

let generalForm = {
    isNull(val) {
        return (!val);
    },
    //
    // Ensure there is a value and that it doesn't exceed maxLength
    //
    isLengthValid(val, maxLength) {
        return (val ? val.length <= maxLength : false);
    },
    isValidEmail(val) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(val);
    },
    
    // Check for valid Phone Number 
    isValidPhone(val) {
        var format = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
        if(val.match(format)) {
            return true;
        }
        else {
            return false;
        }
    }
};

let userForm = {};
let roleForm = {};
export { generalForm, userForm, roleForm };
